import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";

import Slider from "react-slick";
import HttpLinkServices from "../../services/HttpLinkServices";
import Config from "../../config/config";

import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM'
import ErrorModal from "../../components/Modal/ErrorModal";

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const GET_TRAILITEMS = gql`
  query getItens($trail_id: Int!){
    trailitems(trail_id:$trail_id) {
      trailitems{
        item_id, item_type
      }
    }
  }
`;

const GET_CURSES = gql`{
  courses_collections(limit: 8){
    courses{
      id,title,thumbnail
    }
  }
}
`;


const GET_CURSE = gql`
  query getCourse($course_id: Int!){
    course(id:$course_id){
      id, title, thumbnail
    }
  }
`;

const GET_ASSET = gql`
  query getAsset($dam_id: Int!){
    asset(id:$dam_id){
      id, title, thumbnail
    }
  }
`;

const GET_TRAIL = gql`
  query getTrail($trail_id: Int!){
    trail(id:$trail_id){
      id, title, reactionevaluation{
        id, title
      }
    }
  }
`;

const USER_HAS_VIDEO = gql`
  mutation insert_user_has_video($video_id: String!){
    insert_user_has_video(video_id: $video_id){
      id
    }
  }
`;


const USER_HAS_VIDEO_FINISH = gql`
  mutation finish_user_has_video($video_id: String!){
    finish_user_has_video(video_id: $video_id) {
      id
    }
  }
`;


class Video extends Component {
  urlPlayer;
  videoOpen = false;

  constructor() {
    super();
    this.state = {
      like: false,
      favorite: false
    };
  }

  setLike() {
    this.setState(state => ({
      ...state,
      like: !this.state.like
    }));
  }
  setFavorite() {
    this.setState(state => ({
      ...state,
      favorite: !this.state.favorite
    }));
  }

  
  componentDidMount() {
    var videoId = this.props.match.params.video_id;
    var projectId = (window.location.host == 'parceiros.portoseguroeducacao.com.br' ? '3b72ede59a85358f9b2e119467b47b7d' : 'a48377e3ea6d8603fcafcb42130e3369');
    var hash = window.location.hash;
  
    if (videoId && !this.videoOpen) {
      lms_client
        .query({
          query: gql`
            query getVideo($video_id: String!) {
              video(video_id: $video_id) {
                id, title, description, status
              }
            }
          `,
          variables: { video_id: videoId },
        })
        .then((response) => {
          const videoStatus = response.data.video.status;
          this.setState({ videoStatus }); 
  
          if (videoStatus !== "ACTIVE" || videoStatus === undefined) {
            if (hash.includes("lives-gravadas")) {
              window.location.href = `${Config.baseUrl}/api/v1/lms/inative-record`;
            } else if (hash.includes("video")) {
              window.location.href = `${Config.baseUrl}/api/v1/lms/inative-video`;
            }
          } else {
            this.videoOpen = true;
            lms_client.mutate({
              variables: { video_id: videoId },
              mutation: USER_HAS_VIDEO,
            });
  
            // Crie o SambaPlayer aqui, após o sucesso da consulta
            this.createSambaPlayer(projectId, videoId);
          }
        })
        .catch((error) => {
          // Lida com erros na consulta do vídeo, se necessário
          console.error("Erro ao buscar o vídeo:", error);
        });
    }
  }
  
  createSambaPlayer(projectId, videoId) {
    this.player = new window.SambaPlayer("player", {
      height: 360,
      width: 640,
      ph: projectId,
      m: videoId,
      playerParams: {
        enableShare: false,
        captionTheme: [20, 'pt-BR'],
      },
      events: {
        "onListen": this.onListen,
        "onStart": this.handleStartVideoGTM,
        "onPause": this.handlePauseVideoGTM,
        "onResume": this.handleResumeVideoGTM,
        "onFinish": this.onFinishVideoGTM,
        "onMediaView": this.currentProgress,
      },
    });
  }
  


  onListen(player){
    if(typeof this.secsExec === "undefined") {
      this.secsExec = [];
    }
    if(typeof this.confirmView === "undefined") {
      this.confirmView = false;
    }
    if(player.duration && player.duration > 0 && player.event == "onListen"){
      var currentSecVideo = Math.floor(player.eventParam);
      if(!this.secsExec.includes(currentSecVideo)) {
        this.secsExec.push(currentSecVideo);
        var secsExecCount = this.secsExec.length;
        var totalSecs = player.duration/1000;
        if(secsExecCount/totalSecs >= 0.7 && !this.confirmView){
          this.confirmView = true;
          // Definir o vídeo como visto, após 70% de visualização
          lms_client.mutate({
              mutation: USER_HAS_VIDEO_FINISH,
              variables:{video_id: player.id }
          });
        }
      }
     
    }
  }

  handleStartVideoGTM(data) {
    const dataLayer = {
      event: 'video_change',
      titulo: data.title,
      status: 'start',
      progress: '0%'
    }
    addToDataLayerGTM(dataLayer);
  }

  handlePauseVideoGTM = (data) => {
    const duration = data.duration;
    let currentTime;

    this.player.getStatus((data) => currentTime = data.status.time);

    const progress = Math.floor(((currentTime * 100) / duration) * 1000);

    const dataLayer = {
      event: 'video_change',
      titulo: data.title,
      status: 'pause',
      progress: `${progress}%`
    }
    addToDataLayerGTM(dataLayer);
  }

  handleResumeVideoGTM = (data) => {
    const duration = data.duration;
    let currentTime;

    this.player.getStatus((data) => currentTime = data.status.time);

    const progress = Math.floor(((currentTime * 100) / duration) * 1000);
    const dataLayer = {
      event: 'video_change',
      titulo: data.title,
      status: 'play',
      progress: `${progress}%`
    }
    addToDataLayerGTM(dataLayer);
  }

  onFinishVideoGTM(data) {
    const dataLayer = {
      event: 'video_change',
      titulo: data.title,
      status: 'complete',
      progress: '100%'
    }
    addToDataLayerGTM(dataLayer);
  }

  currentProgress(data) {
    const dataLayer = {
      event: 'video_change',
      titulo: data.title,
      status: 'conteudo visualizado',
      progress: data.eventParam,
    }
    addToDataLayerGTM(dataLayer);
}


  render() {

    const { videoStatus } = this.state;

    if (videoStatus === null) {
      return <div>Carregando...</div>;
    } else if (videoStatus !== "ACTIVE" || videoStatus === undefined) {
      // Não renderiza o conteúdo enquanto verifica o status
      return null; 
    } else {
      const windowWidth = window.innerWidth;

      var settings_courses = {
        autoplay: false,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: (windowWidth <= 987 ? 2 : 4),
        slidesToScroll: (windowWidth <= 987 ? 2 : 4)
      };

      return (
        
        <div id="CoursePage">

        <div className="content">
          <Grid fluid>
            <Row>
              <Col md={1}></Col>
              <Col md={10}>
                <div>
                  <div className="embed-responsive embed-responsive-16by9 card shadow-sm">
                    <div id="player"></div>
                  </div>


                  <Query
                    client={lms_client}
                    variables={{ video_id: this.props.match.params.video_id }}
                    query={gql`
                    query getVideo($video_id: String!) {
                      video(video_id:$video_id){
                        id,title,description, status
                      }
                    }
                    `}
                  >
                    {({ loading, error, data }) => {
                      if (loading) return <div>Carregando...</div>;
                      if (error){
                        // Google Tag Manager
                        addToDataLayerGTM({
                          'event' : 'erro',
                          'etapa' : 'erro ao buscar video'
                        });
                        return <ErrorModal />;
                      };

                      // Google Tag Manager
                      const isRecordLive = this.props.match.params.type;
                      const dataLayer = {
                        'event': 'step_change',
                        'etapa': isRecordLive
                            ? `/sala-virtual/aulas-gravadas/${data.video.title}/`
                            : `/conteudos-digitais/videoteca/${data.video.title}/`,
                      }
                      addToDataLayerGTM(dataLayer);
                      // End Google Tag Manager
                      return (
                        <div>
                        <h1>{data.video.title}</h1>
                        <p>{data.video.description ? (data.video.description).replace(/<[^>]*>/g, '') : ""}</p>
                        </div>
                                    
                    );
                  }}
                </Query>

              </div>
            </Col>
            <Col md={1}></Col>
            
          </Row>

          </Grid>
        </div>

          <div className="content content_bar">
            <Grid fluid>
              <Query
                  client={lms_client}
                  query={GET_CURSES}
              >
                {({loading, error, data}) => {
                  if (loading) return <div>Carregando...</div>;
                  if (error){
                    // Google Tag Manager
                    addToDataLayerGTM({
                      'event' : 'erro',
                      'etapa' : 'erro ao buscar cursos'
                    });
                    return <ErrorModal />;
                  };

                  if (!data.courses_collections.courses.length) {
                    return <span></span>;
                  }

                  return (
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2>
                              Mais assistidos
                            </h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_courses}>
                              {data.courses_collections.courses.map((item) => (
                                  <div key={item.id} className="course-item">
                                    <a
                                        data-gtm-type="click"
                                        data-gtm-clicktype="card"
                                        data-gtm-name={item.title}
                                        href={"/#/curso/" + item.id}>
                                      <img src={Config.baseUrl + "/lms/assets/" + item.thumbnail}/>
                                      <div className="title">{item.title}</div>
                                    </a>
                                  </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                  )
                }}
              </Query>

            </Grid>
          </div>
        </div>
      );
    }
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/views/Videos/Video.jsx